import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logos/logo-two.png";
import "./style.css";

function Drawer({ drawer, action }) {
  const [itemSize, setSize] = useState("0px");
  const [item, setItem] = useState("");
  const handler = (e, value) => {
    // e.preventDefault();
    const getItems = document.querySelectorAll(`#${value} li`).length;
    if (getItems > 0) {
      if (item !== value) {
        setSize(`${50 * getItems}px`);
        setItem(value);
      } else {
        setItem("");
      }
    }
  };
  return (
    <>
      <div
        onClick={(e) => action(e)}
        className={`off_canvars_overlay ${drawer ? "active" : ""}`}
      ></div>
      <div className="offcanvas_menu">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div
                className={`offcanvas_menu_wrapper ${drawer ? "active" : ""}`}
              >
                <a
                  href="/"
                  className="offcanvas-brand text-center mb-40 d-block"
                >
                  <img src={logo} alt="" />
                </a>
                <div id="menu" className="text-left ">
                  <ul className="offcanvas_main_menu">
                    <li
                        onClick={(e) => handler(e, "home")}
                        id="home"
                        className="menu-item-has-children active"
                    >
                      <Link to="/">Home</Link>
                    </li>
                    <li
                      onClick={(e) => handler(e, "about")}
                      id="about"
                      className="menu-item-has-children active"
                    >
                      <span className="menu-expand">
                        <i className="fa fa-angle-down"></i>
                      </span>
                      <a href="#">About</a>
                      <ul
                        className="sub-menu"
                        style={{
                          height: item === "about" ? itemSize : "0px",
                        }}
                      >
                        <li>
                          <Link to="/our-ideal-customer">Work With Us</Link>
                        </li>
                        <li>
                          <Link to="/team">Team</Link>
                        </li>
                      </ul>
                    </li>
                    <li
                        onClick={(e) => handler(e, "services")}
                        id="services"
                        className="menu-item-has-children active"
                    >
                      <Link to="/services">Services</Link>
                    </li>
                    <li
                      onClick={(e) => handler(e, "contact")}
                      id="contact"
                      className="menu-item-has-children active"
                    >
                      <Link to="/our-ideal-customer#contact">Contact</Link>
                    </li>
                  </ul>
                </div>
                <div className="offcanvas-social">
                  <ul className="text-center">
                    <li>
                      <a href="https://www.linkedin.com/company/ytec">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="http://twitter.com/ytecnl">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Drawer;
